import React from "react";
//sayani Changes new file
const NotificationAvatarIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-2-inside-1_4787_95914" fill="white">
        <path d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z" />
      </mask>
      <path
        d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
        fill="#1A1A24"
      />
      <path
        d="M24 48V47C11.2975 47 1 36.7026 1 24H0H-1C-1 37.8071 10.1929 49 24 49V48ZM48 24H47C47 36.7026 36.7026 47 24 47V48V49C37.8071 49 49 37.8071 49 24H48ZM24 0V1C36.7026 1 47 11.2975 47 24H48H49C49 10.1929 37.8071 -1 24 -1V0ZM24 0V-1C10.1929 -1 -1 10.1929 -1 24H0H1C1 11.2975 11.2975 1 24 1V0Z"
        fill="#33333E"
        mask="url(#path-2-inside-1_4787_95914)"
      />
      <path
        d="M18.459 12.3334C18.459 11.8501 18.0672 11.4584 17.584 11.4584C17.1007 11.4584 16.709 11.8501 16.709 12.3334C16.709 14.0881 16.3289 15.119 15.7138 15.7291C15.0973 16.3406 14.0645 16.7084 12.334 16.7084C11.8507 16.7084 11.459 17.1001 11.459 17.5834C11.459 18.0666 11.8507 18.4584 12.334 18.4584C14.0586 18.4584 15.0931 18.8347 15.7118 19.4524C16.3302 20.0698 16.709 21.1039 16.709 22.8334C16.709 23.3166 17.1007 23.7084 17.584 23.7084C18.0672 23.7084 18.459 23.3166 18.459 22.8334C18.459 21.1024 18.8356 20.0687 19.4525 19.4519C20.0694 18.835 21.103 18.4584 22.834 18.4584C23.3172 18.4584 23.709 18.0666 23.709 17.5834C23.709 17.1001 23.3172 16.7084 22.834 16.7084C21.0972 16.7084 20.0652 16.3402 19.4505 15.7296C18.8369 15.12 18.459 14.0896 18.459 12.3334Z"
        fill="#FFE600"
      />
      <path
        d="M28.3757 19.3334C28.3757 18.8501 27.9839 18.4584 27.5007 18.4584C27.0174 18.4584 26.6257 18.8501 26.6257 19.3334C26.6257 22.1192 26.0242 23.8792 24.9338 24.9607C23.842 26.0436 22.0801 26.625 19.334 26.625C18.8507 26.625 18.459 27.0168 18.459 27.5C18.459 27.9833 18.8507 28.375 19.334 28.375C22.0742 28.375 23.8378 28.9712 24.9318 30.0634C26.0255 31.1553 26.6257 32.9185 26.6257 35.6667C26.6257 36.15 27.0174 36.5417 27.5007 36.5417C27.9839 36.5417 28.3757 36.15 28.3757 35.6667C28.3757 32.9171 28.9722 31.1542 30.0635 30.0629C31.1549 28.9715 32.9177 28.375 35.6673 28.375C36.1506 28.375 36.5423 27.9833 36.5423 27.5C36.5423 27.0168 36.1506 26.625 35.6673 26.625C32.9119 26.625 31.1507 26.0433 30.0615 24.9612C28.9734 23.8802 28.3757 22.1206 28.3757 19.3334Z"
        fill="#FFE600"
      />
    </svg>
  );
};

export default NotificationAvatarIcon;
